export default __webpack_public_path__ + "522e44372f92166904df493dde2ec37d.svg";